import sidebar from "../../assets/elevate/sidebar.webp";
import email from "../../assets/elevate/email.webp";
import email_detail from "../../assets/elevate/email_detail.webp";
import crm_chat from "../../assets/elevate/crm_chat.webp";
import status from "../../assets/elevate/status.webp";
import elastic_search from "../../assets/elevate/elastic_seach.webp";
import filters from "../../assets/elevate/filters.webp";
import quick_filters from "../../assets/elevate/quick_filters.webp";
import templates from "../../assets/elevate/templates.webp";
import lead_details from "../../assets/elevate/lead_details.webp";
import order_details from "../../assets/elevate/order_details.webp";
import patient_details from "../../assets/elevate/patient_details.webp";
import tickets from "../../assets/elevate/tickets.webp";
import high_level_chat from "../../assets/elevate/high_level_chat.webp";
import notifications from "../../assets/elevate/notifications.webp";
import admin_login from "../../assets/elevate/admin_login.webp";
import patient_main from "../../assets/elevate/patient_main.webp";
import doctor_chat from "../../assets/elevate/doctor_chat.webp";
import sub_details from "../../assets/elevate/sub_details.webp";
import bmi from "../../assets/elevate/bmi.webp";
import patient_login from "../../assets/elevate/patient_login.webp";

import json from "./elevate.json";
import { Project } from "../../components/project";
import { IoIosArrowForward } from "react-icons/io";

const imageMap = {
  sidebar,
  email,
  email_detail,
  crm_chat,
  status,
  elastic_search,
  filters,
  quick_filters,
  templates,
  lead_details,
  order_details,
  patient_details,
  tickets,
  high_level_chat,
  notifications,
  admin_login,
  patient_main,
  doctor_chat,
  sub_details,
  bmi,
  patient_login,
};

export const Elevate = () => {
  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} imageMap={imageMap} />

      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">
        Link to the project
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://elevate.elevatesofts.com/lpv1"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          Elevate Landing Page
        </a>
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <div className="text-[16px] text-secondary hover:opacity-90">
          Elevate Admin Portal (Confidential)
        </div>
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://patient.joinelevate.com/user"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          Elevate Patient Portal
        </a>
      </div>
    </div>
  );
};
